import { Warning, ArrowUpward } from '@mui/icons-material'
import { formatNumber, formatDOS } from '../../utils/format'
import { getDOSStatus } from '../../utils/dos'
import { status as statusTokens } from '../../theme/tokens'

export function DOSCellRenderer({ value, data, colDef }) {
  const monthKey = colDef.field.replace('_dos', '')
  const fcst = data[`${monthKey}_fcst`]
  const dosMin = data.dosMin
  const dosMax = data.dosMax

  if (value == null) return <span style={{ color: '#758075' }}>—</span>

  if (value < 0) {
    return (
      <span style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 2,
        backgroundColor: statusTokens.critical.bg,
        color: statusTokens.critical.color,
        fontWeight: 700,
        padding: '0 6px',
        borderRadius: 4,
        height: 24,
        fontSize: '0.75rem',
      }}>
        NEG
      </span>
    )
  }

  if (!fcst || fcst === 0) {
    return (
      <span style={{
        color: '#758075',
        fontSize: '0.75rem',
        fontStyle: 'italic',
      }}>
        999+
      </span>
    )
  }

  const dosStatus = getDOSStatus(value, dosMin, dosMax)

  if (dosStatus === 'critical') {
    return (
      <span style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 2,
        backgroundColor: statusTokens.critical.bg,
        color: statusTokens.critical.color,
        fontWeight: 600,
        padding: '0 6px',
        borderRadius: 4,
        height: 24,
        fontSize: '0.75rem',
      }}>
        <Warning sx={{ fontSize: 14 }} />
        {formatDOS(value)}
      </span>
    )
  }

  if (dosStatus === 'aboveMax') {
    return (
      <span style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 2,
        backgroundColor: statusTokens.aboveMax.bg,
        color: statusTokens.aboveMax.color,
        fontWeight: 600,
        padding: '0 6px',
        borderRadius: 4,
        height: 24,
        fontSize: '0.75rem',
      }}>
        <ArrowUpward sx={{ fontSize: 14 }} />
        {formatDOS(value)}
      </span>
    )
  }

  return (
    <span style={{ fontSize: '0.75rem', fontWeight: 500, color: '#191C19' }}>
      {formatDOS(value)}
    </span>
  )
}

export function CasesCellRenderer({ value, data, colDef }) {
  const monthKey = colDef.field.replace('_cases', '')
  const isScenarioModified = data[`${monthKey}_scenarioModified`]
  const isOverride = data[`${monthKey}_override`]

  let borderLeft = 'none'
  let position = 'relative'

  if (isOverride) {
    borderLeft = '3px solid #1A9E2A'
  } else if (isScenarioModified) {
    borderLeft = '3px solid #5F8740'
  }

  return (
    <div style={{
      borderLeft,
      paddingLeft: borderLeft !== 'none' ? 4 : 0,
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      position,
      fontSize: '0.8125rem',
    }}>
      {formatNumber(value)}
      {isOverride && (
        <span style={{
          position: 'absolute',
          top: 2,
          right: 2,
          width: 6,
          height: 6,
          borderRadius: '50%',
          backgroundColor: '#1A9E2A',
        }} />
      )}
    </div>
  )
}

export function IssueCellRenderer({ value }) {
  if (!value) return null
  return (
    <Warning sx={{
      fontSize: 16,
      color: '#B45309',
      cursor: 'pointer',
    }} />
  )
}
